import React, { useEffect, useState } from "react";
import "./tax.css";
import Navbar from "../../../components/Navbar/Navbar";
import Blacknavtop from "../../../components/Navbar/Blacknavtop";
import Footer from "../../../components/footer/main";
import Aos from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import { Container } from "@material-ui/core";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";

const Tax = () => {
  const [open, setOpen] = useState(false);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  const [open2, setOpen2] = useState(false);

  const onOpenModal2 = () => setOpen2(true);
  const onCloseModal2 = () => setOpen2(false);
  return (
    <div className="">
      <Blacknavtop />
      <Navbar />

      <div className="pt_10rem bg_smoke pb_5rem">
        <div className="container">
          <p className="text-muted">
            /<a href="/">services</a>/<a href="/services/tax">tax</a>
          </p>
          <h2
            data-aos="fade-right"
            className="fs25"
            className="text-center"
            style={{ width: "80%", margin: "auto" }}
          >
            Get your TAX return filled by professional accountants and save Big!
          </h2>
          <br />
          <br />

          <div className="bg_white bg_div">
            <div className="row">
              <div className="col-lg-6 col-xs-12 left_div pd_25">
                <p className="text-center small_title">
                  Share your drive link with FORM-16 and we will contact you.
                </p>
                <div class="input-group mb-3">
                  <span class="input-group-text" id="basic-addon1">
                    <i class="fas fa-link"></i>
                  </span>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Drive link"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                  />
                  <br />
                </div>
                <div className="text-center">
                  <button type="button" class="btn btn-primary fullbtn mr7">
                    Submit
                  </button>
                </div>
                <div>
                  <br />
                  <p className="text-muted form-info-link">
                    Dont know what is Form-16?
                    <span onClick={onOpenModal} className="t-blue" style={{ cursor: "pointer" }}>
                      Click here
                    </span>
                  </p>
                  <Modal open={open} onClose={onCloseModal} center>
                    <br />
                    <h2>What is FORM16?</h2>
                    <p>
                      For salaried employees, the HR/Finance Department sends you the Form-16. The
                      deadline for receiving Form-16 is 15th Aug 2020, if you haven’t received it
                      yet, then contact your HR.
                    </p>
                  </Modal>
                  <p className="text-muted form-info-link">
                    Doesn't have FORM-16?
                    <span onClick={onOpenModal2} className="t-blue" style={{ cursor: "pointer" }}>
                      Click here
                    </span>
                  </p>
                  <Modal open={open2} onClose={onCloseModal2} center>
                    <br />
                    <h2>Doesn't have FORM16?</h2>
                    <p>Contact us and we will guide you easily.</p>
                    <a
                      style={{ textDecoration: "none", color: "black" }}
                      href="tel:8851956910"
                      target="_blank"
                    >
                      <button type="button" class="btn btn-primary fullbtn mr7">
                        CALL/Whatsapp
                      </button>
                    </a>
                    <br />
                    <br />

                    <p className="text-muted">8851956910</p>
                  </Modal>
                </div>
              </div>
              <div className="col-lg-6 col-xs-12 text-center pd_25">
                <p className="small_title">
                  Schedule or call/whatsapp us and we will you guide in each step.
                </p>
                <a
                  style={{ textDecoration: "none", color: "black" }}
                  href="tel:8851956910"
                  target="_blank"
                >
                  <button type="button" class="btn btn-primary fullbtn mr7">
                    CALL
                  </button>
                </a>
                <p className="text-muted">OR</p>
                <a
                  style={{ textDecoration: "none", color: "black" }}
                  href="https://calendly.com/ca_labs/general"
                  target="_blank"
                >
                  <button type="button" class="btn btn-primary fullbtn mr7">
                    Schedule a meet
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Howitworks />
      <ExpertAssistance />
      <Footer />
    </div>
  );
};

const Howitworks = () => {
  return (
    <div>
      <div className="container pt_5rem">
        <h2 className="text-center" style={{ width: "80%", margin: "auto" }}>
          How it works!
        </h2>
        <div className="row pt_30">
          <div className="col-lg-4">
            <HowStep
              step="1"
              head="Upload Form-16 or Call us"
              sub="We will analyse your income, deductions, TDS and fill ITR."
              image="upload.svg"
            />
          </div>
          <div className="col-lg-4">
            <HowStep
              step="2"
              head="Reviews and Edits"
              sub="We will remain in contact with you from very beginning and reviews and edits."
              image="customer-service.svg"
            />
          </div>
          <div className="col-lg-4">
            <HowStep
              step="3"
              head="ITR Filing is complete"
              sub="We will file with govt. and you will get the acknowledgement from government."
              image="complete.svg"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const HowStep = (props) => {
  return (
    <div className="shortservice_div bg_white">
      <img
        className="shortservice_img"
        src={require(`../../../Assets/${props.image}`)}
        width="60px"
      />
      <p className="text-muted pt_5">STEP - {props.step}</p>
      <h2 className="howservice_h2">{props.head}</h2>
      <p className="text-grey">{props.sub}</p>
    </div>
  );
};

const ExpertAssistance = () => {
  return (
    <div className="pt_5rem pb_5rem ">
      <div className="container bg_smoke pt_2rem pb_2rem br_12px">
        <h1 className="text-center font-weight-bold">OUR EXPERT ASSISTANCE</h1>
        <br />
        <br />

        <div className="taxresponsive_div ">
          <div className="row">
            <div className="col-lg-6">
              <Tickservice text="Your data is reviewed and corrected" />
              <Tickservice text="Best tax saving options will be given" />
              <Tickservice text="ITR filing reminders" />
              <Tickservice text="Various other finance services" />
            </div>
            <div className="col-lg-6">
              <Tickservice text="Tax guidance provided" />
              <Tickservice text="ITR on income from FD, Mutual Funds, property." />
              <Tickservice text="Post return filing updates" />
            </div>
          </div>
          <br />
          <div className="text-center">
            <a
              style={{ textDecoration: "none", color: "black" }}
              href="tel:8851956910"
              target="_blank"
            >
              <button type="button" class="btn btn-primary fullbtngreen mr7">
                CALL / WHATSAPP
              </button>
            </a>
          </div>
        </div>
        <br />
        <br />
      </div>
    </div>
  );
};

const Tickservice = (props) => {
  return (
    <div>
      <div className="row">
        <div className="col-2">
          <img src={require("../../../Assets/tick.svg")} width="100%" />
        </div>
        <div className="col-10">{props.text}</div>
      </div>
    </div>
  );
};

export default Tax;
